import type { SVGComponentProps } from 'BreetHelpers';

// Caret for DropDown.Modern. Drawn pointing up (open state); the control rotates it 180° when closed.
export const DropdownCaretIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='20'
		height='20'
		viewBox='0 0 20 20'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		data-testid='dropdown-caret-icon'
		{...rest}
	>
		<path
			d='M4.16634 12.917L9.99967 7.08366L15.833 12.917'
			stroke='#75808A'
			strokeWidth='1.2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
